/* unplugin-vue-components disabled */import script from "./PostBoardRowShow.vue?vue&type=script&setup=true&lang=ts"
export * from "./PostBoardRowShow.vue?vue&type=script&setup=true&lang=ts"

import "./PostBoardRowShow.vue?vue&type=style&index=0&id=328c454a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-328c454a"]])

export default __exports__